import { daysInMonth } from './misc.js';
/**
 * Adds a unit of time to the input. Similar to Moment, but deals with decimals
 * differently. See note.
 *
 * NOTE: This is only the same as Moment.js for integer inputs! Moment does
 *  some rounding that makes the output different. E.g.:
 *  `moment().add(11.5, 'days')` ends up adding 12 days. It converts years
 *  to months, and rounds that. So `moment.add(2.2, 'years')` ends up adding
 *  26 months instead of 26.4 months.
 *  -
 *  Essentially this is more accurate, and useful for getting a specific date
 *  since we can do `add(input, 1.5, 'y')`, which would require multiple calls
 *  to be accurate w/ moment (`moment(input).add(1, 'y').add(6, 'M')`).
 */
export const add = (dateInput, amount, addUnit) => {
    const d = new Date(dateInput);
    switch (addUnit) {
        case 'ms':
            d.setMilliseconds(d.getMilliseconds() + amount);
            break;
        case 's':
            d.setSeconds(d.getSeconds() + amount);
            break;
        case 'm':
            d.setMinutes(d.getMinutes() + amount);
            break;
        case 'h':
            d.setHours(d.getHours() + amount);
            break;
        case 'w':
            amount *= 7;
        /* falls through */
        case 'd':
            d.setDate(d.getDate() + amount);
            break;
        case 'M': {
            const nextMonth = d.getMonth() + amount;
            const dayOfMonth = Math.min(d.getDate(), daysInMonth(d.getFullYear(), nextMonth));
            d.setMonth(nextMonth, dayOfMonth);
            break;
        }
        case 'y':
            d.setFullYear(d.getFullYear() + amount);
            break;
    }
    return d;
};
//# sourceMappingURL=add.js.map